<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_reports' | translate }} </h3>

<form (ngSubmit)="updateProduct()" enctype="multipart/form-data">
  <div class="row">


              
<div class="col-md-12 mb-3">
  <label class="form-label fw-bold">PDF</label>
  <input type="file" id="pdfUpload" class="form-control" accept="application/pdf" (change)="onPdfSelected($event)">

  <div class="mt-2" *ngIf="pdfName">
<a [href]="product.pdf ? null : product.file_url" target="_blank">{{ pdfName }}</a>
    <button type="button" class="btn btn-sm btn-danger ms-2" (click)="removePdf()">{{ 'MENU.DASHBOARD.remove' | translate }}</button>
  </div>
</div>

 <!-- 🏷 Name -->
<div class="col-md-12">
  <div class="mb-3">
    <label class="form-label required-field">
      {{ 'MENU.DASHBOARD.title' | translate }}
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="product.title"
      name="title"
      required
      #title="ngModel"
      [class.is-invalid]="title.invalid && title.touched"
    />
    <div *ngIf="title.invalid && title.touched" class="text-danger small mt-1">
      {{ 'MENU.DASHBOARD.name_required' | translate }}
    </div>
  </div>
</div>



  </div>

  <!-- 💾 Submit -->
  <div class="text-start mt-3">
    <button type="submit" class="btn px-4" style="background-color: #cca44c !important; color: #fff;">
      {{ 'MENU.DASHBOARD.save_changes' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
